import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function SignalSection() {
  return <section className="py-12 px-4 bg-matrix-surface border-y border-matrix-dim" data-id="element-303">
      <div className="max-w-3xl mx-auto text-center" data-id="element-304">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center" data-id="element-305">
          <AlertCircle className="w-12 h-12 text-matrix-primary mb-6 opacity-80" data-id="element-306" />

          <h2 className="text-3xl md:text-4xl font-bold text-matrix-orange mb-8" data-id="element-307">
            La señal más clara de que ya estás listo
          </h2>

          <div className="space-y-6 text-lg text-matrix-muted max-w-2xl" data-id="element-308">
            <p data-id="element-309">
              Si estás aquí, ya eres "solution aware". Ya lo sabes: necesitas un
              reset.
            </p>
            <ul className="space-y-2 text-matrix-text/80" data-id="element-310">
              <li className="line-through decoration-matrix-red/50 decoration-2" data-id="element-311">
                No otro hilo.
              </li>
              <li className="line-through decoration-matrix-red/50 decoration-2" data-id="element-312">
                No otro video.
              </li>
              <li className="line-through decoration-matrix-red/50 decoration-2" data-id="element-313">
                No otra promesa.
              </li>
            </ul>
            <p className="text-xl md:text-2xl text-matrix-text font-medium pt-4" data-id="element-314">
              Necesitas algo que puedas escuchar, seguir y repetir…{' '}
              <span className="text-matrix-primary" data-id="element-315">
                incluso cuando estés cansado.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}